import React from 'react'

function BlogSite() {
  return (
    <div>index</div>
  )
}

export default BlogSite